import { render, staticRenderFns } from "./BtnCreateModel.vue?vue&type=template&id=e52757be&"
import script from "./BtnCreateModel.vue?vue&type=script&lang=js&"
export * from "./BtnCreateModel.vue?vue&type=script&lang=js&"
import style0 from "./BtnCreateModel.vue?vue&type=style&index=0&id=e52757be&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports